module.exports = __webpack_public_path__ + "static/img/mdi-settings-turnado.0e2609d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/mdi-settings-turnado.jpg
// module id = qoSY
// module chunks = 1